module.exports = __webpack_public_path__ + "static/media/image3.6a4051f4.jpg";